import { Toaster } from "@/components/ui/sonner";
import { useTheme } from "@/context/ThemeContext";

export function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster position="top-right" theme={theme} />;
}
